module.exports = __webpack_public_path__ + "images/sort-down-3381b1bf.png";